module.exports = __webpack_public_path__ + "img/logo_lubie_ludzi.52df68ad.png";